import { render } from "./MessageForm.vue?vue&type=template&id=518a88f8&scoped=true"
import script from "./MessageForm.vue?vue&type=script&lang=js"
export * from "./MessageForm.vue?vue&type=script&lang=js"

import "./MessageForm.vue?vue&type=style&index=0&id=518a88f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518a88f8"]])

export default __exports__